import RecaptchaWrapper from "react-google-recaptcha";

export const AppRecaptchaWrapper = ({...props}) => {
    return (
        <RecaptchaWrapper
            sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
            {...props}
        />
    )
}